import React from 'react';
import { Grid, Typography } from '@mui/material';
import Hashtag from '../images/Hashtag2023.png'
import Logo from '../images/CNM.png'
import RedesSociais from './RedesSociais';

function Footer() {
    return (
        <Grid>
            <footer style={{ textAlign: 'center' }}>
                <Grid>
                    <Grid>
                        <img
                            src="https://www.cnm.org.br/storage/noticias/2023/Imagens/Institucional/estaduaisAtualizadas.png"
                            alt="Estaduais Atualizadas"
                            style={{ borderRadius: '10px', margin: '0 10px', alignSelf: 'center' }}
                            className='estaduais'
                        />
                    </Grid>
                    <Grid sx={{ display: 'flex', flexDirection: { xl: 'row', lg: 'row', xs: 'column' }, alignItems: 'center', justifyContent: 'center' }}>
                        <Grid sx={{ marginTop: '5%' }}>
                            <RedesSociais />
                        </Grid>
                        <img src={Hashtag} alt="#MarchaCNM" style={{ margin: '5% 5% 5% 5%' }} className='image-footer' />
                        <img src={Logo} alt="Logo CNM" style={{ margin: '5% 5% 5% 0' }} className='image-footer' />
                    </Grid>
                    <Grid className='textcopy' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Typography className='textcopy-text' sx={{ fontSize: { xl: '18px', xs: '12px' }, opacity: '0.9', textAlign: 'center' }}>
                            © 2024 | Confederação Nacional de Municípios. Todos os direitos reservados.
                        </Typography>
                    </Grid>
                </Grid>
            </footer>
        </Grid>
    );
}

export default Footer;
